module.exports = __webpack_public_path__ + "static/img/UTSC老师_丁然.6ff7ba2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/studentLanding/UTSC/UTSC老师_丁然.png
// module id = 5is7
// module chunks = 0